var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKingLogo = function SvgKingLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.54 6.534a23.983 23.983 0 0 1 10.453 0l2.196.609L17.5 3.49l-2.294.545c-.557.16-1.18.032-1.639-.32L8.75 0 3.933 3.683a1.878 1.878 0 0 1-1.639.32L0 3.46l1.31 3.652 2.23-.577Z",
    fill: "#EE9C1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.835 10.076h9.831v12.271H3.835z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m2.195 8.717-2.13.48v9.161c0 1.537.688 2.979 1.867 3.972L8.75 28l6.784-5.67a5.235 5.235 0 0 0 1.868-3.972v-9.16l-2.098-.48a29.216 29.216 0 0 0-13.108 0Zm4.948 13.709L8.16 17.14H5.013l5.407-6.342-1.016 5.285h3.146l-5.407 6.342Z",
    fill: "#0B74E2"
  })));
};
export default SvgKingLogo;